module.exports = __webpack_public_path__ + "static/img/02.9db9fe8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/placestogo/02/02.jpg
// module id = GLkj
// module chunks = 0